import {formatUnitQuantity} from '@/app-core/lib/utils/currency/currency'

export default {
  name      : 'ProductQuantity',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    product: {
      type   : Object,
      default: undefined
    },

    textClass: {
      type   : String,
      default: 'align-center'
    },

    textColorClass: {
      type   : String,
      default: 'orange--text'
    },

    borderColorClass: {
      type   : String,
      default: 'brand-primary'
    },

    outlined: {
      type   : Boolean,
      default: false
    },

    hideMultiplySymbol: {
      type   : Boolean,
      default: false
    },

    disabled: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    formatUnitQuantity,
    getMeasurementUnitById(id) {
      if (!id) return null

      return this.$t('Common.Units')?.find(item => item.Id === id) || null
    }
  }
}
